module.exports = __webpack_public_path__ + "img/angststoerungen1_960.477e824e.webp";